// This is free and unencumbered software released into the public domain.
// See LICENSE.md for more information.

var encoding = require("./lib/encoding.js");

module.exports = {
  TextEncoder: encoding.TextEncoder,
  TextDecoder: encoding.TextDecoder,
};



//////////////////
// WEBPACK FOOTER
// ../~/text-encoding/index.js
// module id = 1668
// module chunks = 2